export function getBreakpointsClassNames({ breakpoints, mappers, }) {
    return Object.entries(breakpoints).reduce((acc, [breakpoint, props]) => {
        for (const data of Object.entries(mappers)) {
            const [propName, mapper] = data;
            const value = props[propName];
            if (value) {
                if (!acc[propName]) {
                    acc[propName] = [];
                }
                const classNames = mapper(value);
                if (classNames) {
                    acc[propName].push(...classNames.map(className => className + `-breakpoint-${breakpoint}`));
                }
            }
        }
        return acc;
    }, {});
}
//# sourceMappingURL=get-breakpoints-class-names.js.map